<template>
  <div>
    <div class="content">
      <div class="content-main">
        <p class="content-title">盘点审核<un-lock/><page-desc/></p>
        <div class="content-input">
          <div class="content-input-left">
            <div class="content-input-item">
              <label>所属门店</label>
              <el-select v-model="shopId" placeholder="Select" class="select-item">
                <el-option v-for="item in shopIdArray" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item">
              <label>审核状态</label>
              <el-select v-model="state" placeholder="Select" class="select-item">
                <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item">
              <label>添加人</label>
              <SearchComponents :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" width="7em"/>
              <el-checkbox v-model="limitState" style="margin-left: 8px;"><span style="white-space: nowrap; flex-shrink: 0">有限制</span></el-checkbox>
            </div>
            <div class="content-input-item">
              <DatePickerRange title="盘点时间" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
            </div>

          </div>
          <div class="content-input-right">
            <div class="content-input-btn">
              <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getAuditPage(true)"> 查询 </ElButtons>
            </div>
            <div class="content-input-btn">
              <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
            </div>
          </div>

        </div>
      </div>
      <div class="content-main">
        <div class="content-button">
          <div>
<!--            <el-button type="primary" @click="editCommodityDialog(-1)" size="default">添加</el-button>-->
          </div>
          <BtnGroup :colList="colList" @colListChange="colListChange($event)" @refresh="getAuditPage"></BtnGroup>
        </div>
        <div class="content-table">
          <el-table
              ref="multipleTableRef"
              :data="pageDataList"
              style="width: 100%; "
              v-loading="listLoading"
              @cell-click="toggleSelection"
              size="default"
              border
          >
            <!--            <el-table-column property="id" label="ID" v-if="checkColList.indexOf('ID') > -1"/>-->
            <el-table-column property="shopName" label="所属门店" v-if="checkColList.indexOf('所属门店') > -1"/>
            <el-table-column property="updateTime" label="盘点时间" v-if="checkColList.indexOf('盘点时间') > -1"/>
            <el-table-column property="" label="审核状态" v-if="checkColList.indexOf('审核状态') > -1">
              <template #default="scope">
                <p :style="{color: scope.row.state == 2?'red':''}">{{scope.row.state == 0?'待提交':scope.row.state == 1?'审核中':scope.row.state == 2?'不通过':scope.row.state == 3?'已通过':'' }}</p>
              </template>
            </el-table-column>
            <el-table-column property="adminName" label="添加人" v-if="checkColList.indexOf('添加人') > -1"/>
            <el-table-column label="操作" v-if="checkColList.indexOf('操作') > -1">
              <template #default="scope">
                <el-space wrap>
                  <el-button @click="stockAuditListDialog(scope.$index,scope.row)" size="small" type="primary">审核</el-button>
                </el-space>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { getFormData, postFormData } from "@/api/api";
import {getStockTakePageList} from "@/api/url";
import Dialog from "@/assets/js/dialog"
import BtnGroup from '../../components/BtnGroup'
import SearchComponents from "@/components/SearchComponents";
import Drawer from "@/assets/js/drawer";
import UserImgList from "@/components/imgList/UserImgList";
import DatePickerRange from "@/components/DatePickerRange_365";
import StockRemarkDialog from "@/views/stock/components/StockRemarkDialog";
import StockAuditListDialog from "@/views/stock/components/StockAuditListDialog";
import unLock from "@/layout/components/unLock";

export default {
  name: "StockAudit",
  components: { BtnGroup, SearchComponents,DatePickerRange, unLock },
  data() {
    return {
      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,

      limitState: false,

      shopIdArray: [
        {name: '不限', id: 0}
      ],
      shopIdArr:[],
      shopId: 0,

      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      stateArray: [
        {label: '不限', value: -1},
        {label: '待提交', value: 0},
        {label: '审核中', value: 1},
        {label: '不通过', value: 2},
        {label: '已通过', value: 3},
      ],
      state: 1,

      //刷新组
      colList: ['所属门店', '盘点时间', '审核状态', '添加人', '操作'],
      checkColList: [],

      //搜索
      searchTypeList: [
        {label : '商品名称', value : 1},
      ],
      searchType: 1,
      searchValue: '',

    }
  },
  methods: {
    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.state = 1;
      this.limitState = false;
      this.searchValue = '';
      this.searchType = 1;
      setTimeout(()=> {
        this.getAuditPage(true);
      }, 500)
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    typeChange() {
      this.subTypeId = 0
      this.subTypeList = [
        {name: '不限', id: 0}
      ]
      if(this.typeId != 0) {
        for(let i=0; i<this.typeList.length; i++) {
          if(this.typeId == this.typeList[i].id) {
            this.subTypeList = this.subTypeList.concat(this.typeList[i].subTypeList)
          }
        }
      }
    },


    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getAuditPage();
    },

    getAuditPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getAuditPageParam(this.currentPage));
      }
    },

    //页面参数
    getAuditPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['limitState'] = this.limitState?1:0;
      // param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['pageType'] = 2;
      param['state'] = this.state;
      param['shopId'] = this.shopId;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getStockTakePageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },


    stockAuditListDialog(idx, row) {
      let _title = '商品审核';
      let auditForm = Object.assign({}, row);
      Dialog.open({
        title: _title,
        component: StockAuditListDialog,
        data: {
          auditForm: auditForm,
          ids: idx,
          width: '1400px',
        },
        close: (result) => {
          this.getAuditPage()
        }
      })
    },


    userImgList(row) {
      let _title = '';
      _title = '图片列表'
      Drawer.open({
        title: _title,
        component: UserImgList,
        data: {
          imgArray: row.commodityImgList,
          id: row.id,
          width: 908,
          from: 2
        },
        confirm: (result) => {
          this.getAuditPage()
        }
      })
    },

    toggleSelection(row, column, cell, event) {

      //更新用户日志
      if (column.label == '备注') {
        let remarkForm = Object.assign({}, row);
        Dialog.open({
          title: '备注',
          component: StockRemarkDialog,
          data: {
            remarkForm: remarkForm,
            width: '500px'
          },
          close: () => {
            this.getAuditPage()
          }
        })
      }
    },



  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    let ownShopList = JSON.parse(sessionStorage.getItem('ownShopList'))
    this.shopIdArray = this.shopIdArray.concat(ownShopList)
    // this.shopId = this.shopIdArray[0].id
    this.getAuditPage();
    // this.getSupplierList()
    // this.getBrandList()
    // this.getAllCommodityTypeList()
  }
}
</script>

<style scoped>
/*.el-table {*/
/*  --el-table-header-bg-color: #ffffff !important;*/
/*}*/
.item-img {
  width: 80px;
  height: 80px;
}
</style>
